import { render, staticRenderFns } from "./EditReportingProfile.vue?vue&type=template&id=48027926&"
import script from "./EditReportingProfile.vue?vue&type=script&lang=js&"
export * from "./EditReportingProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports